import { ThirdPartyLoginCredentials } from "@app/core/user/domain/third-party-login-credentials";

export class ThirdPartyLoginMapper {
  static serialize(credentials: ThirdPartyLoginCredentials) {
    return {
      token: credentials.token,
      ...(!!credentials.given_name && { given_name: credentials.given_name }),
      ...(!!credentials.family_name && {
        family_name: credentials.family_name,
      }),
    };
  }
}
